import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { ApplicationUpdateService } from '@/services/application-update.service'
import { AuthenticationService } from '@/services/authentication.service';
import { StorageMigrationService } from '@/services/storage-migration.service';
import { User } from '@/domain/user';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html' 
})
export class AppComponent {
  currentUser: User;

  whom = { value: 'world' }

  constructor(
    private translate: TranslateService,
    private appUpdate: ApplicationUpdateService,
    private authenticationService: AuthenticationService,
    private storageMigration: StorageMigrationService,
    private router: Router
  ) {
    // Run storage migration FIRST, before any service tries to read localStorage/sessionStorage
    // This ensures backward compatibility with old data formats
    this.storageMigration.migrateIfNeeded()
    
    appUpdate.init()

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('fi');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fi');

    // Subscribe to user data changes only, not token-only updates
    // This prevents unnecessary assignments during token refresh
    this.authenticationService.userDataChanges$.subscribe(x => {
      const wasLoggedIn = !!this.currentUser
      this.currentUser = x
      // Navigate to login when user becomes null (e.g., cross-tab logout)
      if (wasLoggedIn && !x) {
        this.router.navigate(['/login'])
      }
    });
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}
